import actions from './serviceIcons/actions.svg';
import admin from './serviceIcons/admin.svg';
import aifabric from './serviceIcons/aifabric.svg';
import apps from './serviceIcons/apps.svg';
import automationhub from './serviceIcons/automationhub.svg';
import automationstore from './serviceIcons/automationstore.svg';
import chatbots from './serviceIcons/chatbots.svg';
import dataservice from './serviceIcons/dataservice.svg';
import du from './serviceIcons/du.svg';
import help from './serviceIcons/help.svg';
import home from './serviceIcons/home.svg';
import insights from './serviceIcons/insights.svg';
import integrations from './serviceIcons/integrations.svg';
import marketplace from './serviceIcons/marketplace.svg';
import more from './serviceIcons/more.svg';
import orchestrator from './serviceIcons/orchestrator.svg';
import processes from './serviceIcons/processes.svg';
import processmining from './serviceIcons/processmining.svg';
import reinfer from './serviceIcons/reinfer.svg';
import roboticsops from './serviceIcons/roboticsops.svg';
import studio from './serviceIcons/studio.svg';
import taskmining from './serviceIcons/taskmining.svg';
import testmanager from './serviceIcons/testmanager.svg';
import vpnadmin from './serviceIcons/vpnadmin.svg';

const map = [
    {
        id: 'actions',
        svg: actions,
        name: 'Actions',
    },
    {
        id: 'admin',
        svg: admin,
    },
    {
        id: 'aifabric',
        svg: aifabric,
        name: 'AI Center',
    },
    {
        id: 'apps',
        svg: apps,
        name: 'Apps',
    },
    {
        id: 'automationhub',
        svg: automationhub,
        name: 'Automation Hub',
    },
    {
        id: 'reinfer',
        svg: reinfer,
        name: 'Communications Mining',
    },
    {
        id: 'roboticsops',
        svg: roboticsops,
        name: 'Automation Ops',
    },
    {
        id: 'du',
        svg: du,
        name: 'Document Understanding',
    },
    {
        id: 'automationstore',
        svg: automationstore,
        name: 'Automation Store',
    },
    {
        id: 'chatbots',
        svg: chatbots,
        name: 'Chatbots',
    },
    {
        id: 'dataservice',
        svg: dataservice,
        name: 'Data Service',
    },
    {
        id: 'insights',
        svg: insights,
        name: 'Insights',
    },
    {
        id: 'marketplace',
        svg: marketplace,
        name: 'Marketplace',
    },
    {
        id: 'help',
        svg: help,
        name: 'Help',
    },
    {
        id: 'home',
        svg: home,
        name: 'Home',
    },
    {
        id: 'orchestrator',
        svg: orchestrator,
        name: 'Orchestrator',
    },
    {
        id: 'processes',
        svg: processes,
        name: 'Process Launcher',
    },
    {
        id: 'taskmining',
        svg: taskmining,
        name: 'Task Mining',
    },
    {
        id: 'processmining',
        svg: processmining,
        name: 'Process Mining',
    },
    {
        id: 'studio',
        svg: studio,
        name: 'Studio',
    },
    {
        id: 'testmanager',
        svg: testmanager,
        name: 'Test Manager',
    },
    {
        id: 'integrations',
        svg: integrations,
        name: 'Connections',
    },
    {
        id: 'more',
        svg: more,
    },
    {
        id: 'vpn gateway',
        svg: vpnadmin,
    },
    {
        id: 'cloud robots',
        name: 'Cloud Robots',
        svg: vpnadmin,
    },
    {
        id: 'hypervisor',
        name: 'Cloud Robots',
    },
    {
        id: 'portal',
        name: 'Automation Cloud',
    },
];

const getSvg = (key: string) => {
    const svg = map.find(serviceMapping => serviceMapping.id === key)?.svg;
    return svg ? svg : aifabric;
};

export const getTitle = (key: string) => {
    const title = map.find(serviceMapping => serviceMapping.id === key)?.name;
    return title ? title : key;
};

export const idToSvg = map.reduce((accum, curr) => ({
    ...accum,
    [curr.id]: curr.svg,
}), {});

export default getSvg;
